import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AbpHttpInterceptor } from 'abp-ng2-module';

import * as ApiServiceProxies from './service-proxies';

@NgModule({
    providers: [
        ApiServiceProxies.RoleServiceProxy,
        ApiServiceProxies.SessionServiceProxy,
        ApiServiceProxies.TenantServiceProxy,
        ApiServiceProxies.UserServiceProxy,
        ApiServiceProxies.TokenAuthServiceProxy,
        ApiServiceProxies.AccountServiceProxy,
        ApiServiceProxies.CityServiceProxy,
        ApiServiceProxies.CountryServiceProxy,
        ApiServiceProxies.DistrictServiceProxy,
        ApiServiceProxies.DepartmentServiceProxy,
        ApiServiceProxies.ActivityServiceProxy,
        ApiServiceProxies.PresenceIndicatorServiceProxy,
        ApiServiceProxies.AuditLogServiceProxy,
        ApiServiceProxies.CurrencyTypeServiceProxy,
        ApiServiceProxies.CreditNoteReasonServiceProxy,
        ApiServiceProxies.RemissionNoteReasonServiceProxy,
        ApiServiceProxies.RegimeServiceProxy,
        ApiServiceProxies.DocumentTypeServiceProxy,
        ApiServiceProxies.CardTypeServiceProxy,
        ApiServiceProxies.NomenclatureServiceProxy,
        ApiServiceProxies.TransactionTypeServiceProxy,
        ApiServiceProxies.MeasurementUnitServiceProxy,
        ApiServiceProxies.PaymentMethodServiceProxy,
        ApiServiceProxies.FuelTypeServiceProxy,
        ApiServiceProxies.IdentityDocumentTypeServiceProxy,
        ApiServiceProxies.TaxTypeServiceProxy,
        ApiServiceProxies.BranchServiceProxy,
        ApiServiceProxies.SignatureServiceProxy,
        ApiServiceProxies.ElectronicDocumentServiceProxy,
        ApiServiceProxies.ElectronicDocumentBulkServiceProxy,
        ApiServiceProxies.ReceiverServiceProxy,
        ApiServiceProxies.ElectronicDocumentReceptionServiceProxy,
        ApiServiceProxies.EventReceiverServiceProxy,
        ApiServiceProxies.EventIssuerServiceProxy,
        ApiServiceProxies.QRCodeServiceProxy,
        ApiServiceProxies.ReportsServiceProxy,
        ApiServiceProxies.MerchandiseNegotiationConditionServiceProxy,
        ApiServiceProxies.ProductServiceProxy,
        ApiServiceProxies.SummariesServiceProxy,
        ApiServiceProxies.DefaultProductDataServiceProxy,
        ApiServiceProxies.DefaultReceiversDataServiceProxy,
        ApiServiceProxies.DefaultElectronicDocumentDataServiceProxy,
        ApiServiceProxies.SMTPServerServiceProxy,
        ApiServiceProxies.WebhookServiceProxy,
        ApiServiceProxies.ElectronicDocumentTemplateServiceProxy,
        ApiServiceProxies.StockServiceProxy,
        ApiServiceProxies.ShoppingServiceProxy,
        ApiServiceProxies.UserBranchServiceProxy,
        { provide: HTTP_INTERCEPTORS, useClass: AbpHttpInterceptor, multi: true }
    ]
})
export class ServiceProxyModule { }
